import React from 'react';
const bonuses = [{
  id: 'A',
  title: 'Bono A: Plantillas Word editables',
  desc: '(informes, consentimientos, planillas)',
  img: 'https://cdn.magicpatterns.com/uploads/2T4zEVNzCpMxs5oxpVxjCA/Diseno_sin_titulo_(12).png'
}, {
  id: 'B',
  title: 'Bono B: Juegos imprimibles',
  desc: 'por edad/objetivo',
  img: 'https://cdn.magicpatterns.com/uploads/echsbhaQX7KY4LhESYj3fj/Diseno_sin_titulo_(10).png'
}, {
  id: 'C',
  title: 'Bono C: 30 sesiones listas',
  desc: '(guías "1 sesión")',
  img: 'https://cdn.magicpatterns.com/uploads/t6HFDqdo1WfXhKE1HSX6nD/Diseno_sin_titulo_(11).png'
}];
export function BonusSection() {
  return <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-orange-500 to-orange-600 text-white" data-id="element-18">
      <div className="max-w-6xl mx-auto text-center" data-id="element-19">
        <h2 className="text-5xl md:text-6xl font-black mb-4 uppercase tracking-tight drop-shadow-lg" data-id="element-20">
          BONOS EXCLUSIVOS
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-yellow-300 mb-16 uppercase animate-pulse" data-id="element-21">
          🎁 ¡GRATIS POR EL DÍA DE HOY!
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-22">
          {bonuses.map(bonus => <div key={bonus.id} className="flex flex-col items-center bg-white rounded-2xl p-6 text-gray-900 shadow-2xl transform hover:scale-105 transition-transform duration-300 relative" data-id="element-23">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-yellow-400 text-black font-black px-6 py-2 rounded-full text-xl shadow-lg border-2 border-white z-10 uppercase" data-id="element-24">
                GRATIS
              </div>

              <a href="https://payments.vantapro.shop/cart/44978652708966:1" className="w-full mb-6 mt-4 block" data-id="element-25">
                <div className="w-full aspect-square relative overflow-hidden rounded-lg bg-gray-50" data-id="element-26">
                  <img src={bonus.img} alt={bonus.title} className="absolute inset-0 w-full h-full object-contain" data-id="element-27" />
                </div>
              </a>

              <h4 className="text-2xl font-black mb-2 text-center leading-tight" data-id="element-28">
                {bonus.title}
              </h4>
              <p className="text-lg text-gray-600 font-medium text-center" data-id="element-29">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}